<template>
	<v-form ref="form">
		<v-card-text class="pt-0 pb-0">
			<template v-if="!isLoginInProgress && UsersList.length === 0">
				<v-row dense justify="center">

					<v-col cols="12">
						<v-btn
							color="primary"
							width="100%"
							large
							style="text-transform: none;"
							:disabled="isRedirectingToFreja"
							:loading="isLoginInProgress"
							@click="onStartLogin('BANKID')"
							depressed
						>
							<img
								:src="require('@/assets/img/BankID_logo_white.svg')"
								height="48"
								width="48"
							/>
							Fortsätt med BankID
						</v-btn>
					</v-col>

					<v-col cols="12">
						<v-btn
							color="primary"
							width="100%"
							large
							style="text-transform: none;"
							:disabled="isLoginInProgress"
							:loading="isRedirectingToFreja"
							@click="onStartLogin('FREJAEID')"
							depressed
						>
							<img
								:src="require('@/assets/img/FrejaSmallTransparentWhite.png')"
								height="35"
								width="35"
								style="margin-left: -8px; margin-right: 8px;"
							/>
							Fortsätt med Freja
						</v-btn>
					</v-col>
				</v-row>
			</template>

			<template v-if="UsersList.length === 0">
				<v-row dense justify="center" v-if="isLoginInProgress">
					<v-col cols="12" class="text-center pb-0">
						<v-progress-circular v-if="!statusText" color="accent" :size="50" indeterminate class="mr-2 mb-2"/>
						<p v-if="statusText" :aria-label="statusText">{{statusText}}</p>
					</v-col>

					<v-fade-transition hide-on-leave>
						<v-col v-if="QRCodeDataURL" class="pt-0 pb-5">
							<v-card flat height="220">
								<v-card-text class="pa-0 ma-0 text-center">
									<img v-if="QRCodeDataURL" :src="QRCodeDataURL" height="220" width="220" style="margin: 0 auto; border: 1px solid gray;"/>
								</v-card-text>
							</v-card>
						</v-col>
					</v-fade-transition>
				</v-row>
			</template>

			<template v-else>
				<v-subheader class="subtitle-1 ml-0 pl-2">Välj användarkonto</v-subheader>
				<v-list outlined class="pa-0 ma-0">
					<v-list-item v-for="(item, index) in UsersList" :key="index" @click="onSelectUser(item)">
						<v-list-item-content>
							<v-list-item-title>{{item.Login}}</v-list-item-title>
							<v-list-item-subtitle>{{$formatter.getRollText(item.Roll)}}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</template>
		</v-card-text>
		<v-card-actions>
			<v-row dense justify="center">
				<v-col cols="12" lg="8" xl="6" class="text-center">
					<v-btn width="100%" v-if="AutoStartToken && QRCodeDataURL" depressed color="primary" class="mb-2" @click="tryStartBankIDApp">Starta BankID på den här enheten</v-btn>
					<v-btn width="100%" v-if="isLoginInProgress || UsersList.length > 0" depressed  color="secondary" @click="onCancel">Avbryt inloggning</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-form>
</template>

<script>
import isMobile     from 'is-mobile';
import {mapActions} from 'vuex';
import LocalStorage from '../../lib/LocalStorage.js';

export default {
	name: 'ElectronicIDLogin',
	data: () => ({
		isLoginInProgress:       false,
		isRedirectingToFreja:    false,
		statusText:              '',
		UsersList:               [],
		QRCodeDataURL:           '',
		AutoStartToken:          null,
		startFailedRetryCounter: 0,
	}),

	methods: {
		...mapActions(['setAuthenticated']),

		onSelectUser(user) {
			this.$tryCatch({
				task: async () => {
					const {UserAccount, UserAppSettings, HasPlus, Supplier, HasLicensOption, EnforceBankIDAuth} = await this.$http.post('/bankidauth/selectuser', {
						BankIDToken: user.BankIDToken,
						Login:       user.Login,
					});

					if(UserAppSettings && ['dark', 'white'].includes(UserAppSettings.Theme)) {
						this.$vuetify.theme.dark = UserAppSettings.Theme === 'dark';
					}

					this.setAuthenticated({UserAccount, UserAppSettings, HasPlus, Supplier, HasLicensOption, EnforceBankIDAuth});
				},
			})
		},

		onCancel() {
			clearInterval(this.collectInterval);
			this.UsersList = [];
			this.statusText = '';
			this.isLoginInProgress = false;
			this.QRCodeDataURL = '';
			this.isCollecting = false;
			this.startFailedRetryCounter = 0;

			const currentOrderRef = this.currentOrderRef;

			this.currentOrderRef = null;

			if(currentOrderRef) {
				this.$tryCatch({
					task: async () => {
						await this.$http.delete(`/bankidauth/cancel/${encodeURIComponent(currentOrderRef)}`)
					},
				});
			}
		},

		onStartLogin(Type, {resetStartFailedRetryCounter = true} = {}) {
			LocalStorage.set('LoginMethod', 0);

			if(resetStartFailedRetryCounter) {
				this.startFailedRetryCounter = 0;
			}

			if(Type === 'BANKID') {
				this.$tryCatch({
					task: async () => {
						this.isLoginInProgress = true;

						const {OrderRef, AutoStartToken} = await this.$http.post('/bankidauth', {});

						this.currentOrderRef = OrderRef;
						this.AutoStartToken = AutoStartToken;

						this.collect(OrderRef);

						if(isMobile()) {
							this.tryStartBankIDApp();
						}
					},
					error: () => {
						this.isLoginInProgress = false;
					},
				});
			} else if(Type === 'FREJAEID') {
				this.isRedirectingToFreja = true;
				window.location.href = this.$buildURL('/oidc/authorize/frejaeid', {apiRoute: true});
			}
		},

		tryStartBankIDApp() {
			const params = [
				`autostarttoken=${this.AutoStartToken}`,
				'redirect=null',
			];

			window.location = `bankid:///?${params.join('&')}`;
		},

		collect(orderRef) {
			const collect = async () => {
				if(this.isCollecting) {
					return false;
				}

				if(this.collectAttempts > 60) {
					this.onCancel();

					return;
				}

				try {
					this.isCollecting = true;

					const {
						UsersList,
						Completed,
						Cancelled,
						Message,
						QRCodeDataURL,
						PendingStart,
						StartFailed,
					} = await this.$http.get(`/bankidauth/collect/${orderRef}`);

					if(Cancelled || Completed || StartFailed) {
						clearInterval(this.collectInterval);

						if(StartFailed && this.startFailedRetryCounter < 5) {
							this.startFailedRetryCounter++;
							this.onStartLogin('BANKID', {resetStartFailedRetryCounter: false});

							return;
						} else if(Cancelled || StartFailed) {
							setTimeout(() => {
								this.statusText    = Message;
							}, 7000);
							setTimeout(() => {
								this.isLoginInProgress = false;
							}, 10000);
						} else {
							this.isLoginInProgress = false;
						}
					}

					if(PendingStart && QRCodeDataURL) {
						this.QRCodeDataURL = QRCodeDataURL;
						this.statusText    = 'Skanna QR-koden i BankID-appen';
					} else {
						this.QRCodeDataURL = '';
						if(!Cancelled) {
							this.statusText    = Message;
						}
					}

					if(Completed) {
						if(UsersList.length === 0) {
							this.$msgError('Det finns inga användarkonton kopplat till ditt personnummer.');
							
							return;
						}

						// if(UsersList.length === 1) {
						// 	this.onSelectUser(UsersList[0]);
						// 	return;
						// }

						this.UsersList = UsersList;
					}
				} catch {
					this.isLoginInProgress = false;
					clearInterval(this.collectInterval);
				} finally {
					this.isCollecting = false;
					this.collectAttempts = this.collectAttempts + 1;
				}
			};

			if(this.collectInterval) {
				clearInterval(this.collectInterval);
			}

			this.collectAttempts = 0;
			this.collectInterval = setInterval(collect, 1500);

			collect();
		},
	},
}
</script>

<style scoped>

</style>
